module.exports = __webpack_public_path__ + "img/toe-strike-shoe.ccf863f8.svg";